export default "__VITE_ASSET__Co1GAQW___"